<template>
    <v-dialog v-model="dialog" persistent max-width="700" @keydown.esc="chiudi()">
        <v-card height="560">
            <v-toolbar dark color="primary" dense>
                <v-btn icon dark v-on:click="chiudi()">
                    <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>Differenze </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>

            <v-data-table :headers="headers" :items="dati" item-key="Prog" class="ma-2" no-data-text=""
                :loading="attesaCaricamento" dense hide-default-footer disable-pagination show-select>

                <template v-slot:item.Differenze="{ item }">
                    <div class="wrap-cell">
                        {{ item.Differenze }}
                    </div>
                </template>

            </v-data-table>

        </v-card>
    </v-dialog>
</template>


<script>
import { duplica_differenzeRighe } from "@/api/api.ordini.js";

export default {
    props: {
        dialog: { type: Boolean, default: false },
        idPrev: { type: Number, default: 0 },
    },

    data: () => ({

        headers: [
            { text: "Prog", value: "Prog", width: '90px' },
            { text: "Descrizione", value: "Differenze" },
        ],
        dati: [],

        attesaCaricamento: false

    }),

    methods: {
        async caricaDati() {
            // Reset
            this.dati = [];

            if (this.dialog == false) return;

            try {
                this.attesaCaricamento = true

                let res = await duplica_differenzeRighe(this.idPrev);

                this.dati = res.data;

            } catch (error) {
                console.log(error);
            }

            this.attesaCaricamento = false

        },

        chiudi() {
            this.$emit("chiudiDialog");
        },

    },

    mounted() {
        this.caricaDati();
    },

    watch: {
        dialog(val) {
            this.caricaDati();
        },
    },

}
</script>

<style scoped>
.wrap-cell {
    white-space: pre-line;
    overflow-wrap: anywhere;
    word-break: break-word;
    min-width: 0;
}
</style>